/******* Angular Resourse *******/
import { Inject, Injectable, Optional } from '@angular/core';
import { BaseApi } from '@api/base/base.service';
import { HttpClient } from '@angular/common/http';
import { AuthTokenRequestBody, CheckingAuthCodeRequestBody, LoginRequestBody, SendingAuthCodeRequestBody, TwoFactorType } from '@core/types';

@Injectable()
export class Auth extends BaseApi {

    constructor(@Inject(HttpClient) protected http: HttpClient) {
        super(http);
    }

    /**
     * POST /auth/login - becentral login
     * 
     * @param {LoginRequestBody} data  
     */
    public login(data: LoginRequestBody) {

        let method = "POST",
            url = "auth/login",
            routeParams = {},
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * POST /auth/token - get the access token at first time
     * 
     * @param {AuthTokenRequestBody} data  
     */
    public getToken(data: AuthTokenRequestBody) {

        let method = "POST",
            url = "auth/token",
            routeParams = {},
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * POST /auth/token-refresh - refresh the access token
     */
    public refreshToken() {

        let method = "POST",
            url = "auth/token-refresh",
            routeParams = {},
            urlParams = {},
            postBody = {};

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * POST /auth/logout - becentral logout
     */
    public logout() {

        let method = "POST",
            url = "auth/logout",
            routeParams = {},
            urlParams = {},
            postBody = {};

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * POST /auth/2fa/email - send auth code thru email
     * 
     * @param {SendingAuthCodeRequestBody} data
     */
    public sendingAuthCodeEmail(data: SendingAuthCodeRequestBody) {

        let method = "POST",
            url = "auth/2fa/email",
            routeParams = {},
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * POST /auth/2fa/sms - send auth code thru sms
     * 
     * @param {SendingAuthCodeRequestBody} data
     */
    public sendingAuthCodeSms(data: SendingAuthCodeRequestBody) {

        let method = "POST",
            url = "auth/2fa/sms",
            routeParams = {},
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * POST /auth/2fa/check - check auth code
     * 
     * @param {CheckingAuthCodeRequestBody} data
     */
    public checkAuthCode(data: CheckingAuthCodeRequestBody) {

        let method = "POST",
            url = "auth/2fa/check",
            routeParams = {},
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * GET /auth/google - access sso google
     * 
     * @param {string} client_id
     * @param {string} client_secret
     */
    public authGoogle(client_id: string, client_secret: string) {

        let method = "GET",
            url = "auth/google",
            routeParams = {},
            urlParams = { client_id, client_secret },
            postBody = {};

        return this.request(method, url, routeParams, urlParams, postBody);
    }
}